import { render, staticRenderFns } from "./AIClassification.vue?vue&type=template&id=3c489a2b"
import script from "./AIClassification.vue?vue&type=script&lang=js"
export * from "./AIClassification.vue?vue&type=script&lang=js"
import style0 from "./AIClassification.vue?vue&type=style&index=0&id=3c489a2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports